import { useRuntimeConfig } from '#app'
import { useParentPickupStore } from '~/stores/parentPickup'
import { useAuthState } from '~/composables/useAuthState'

export default defineNuxtRouteMiddleware((to) => {
  // Respect runtime flag to disable auth for testing
  const config = useRuntimeConfig()
  const authEnabled = String(config.public.authEnabled).toLowerCase() === 'true'
  if (!authEnabled) {
    console.info('ParentAuth middleware skipped: auth disabled via config')
    return
  }

  // Use our composable for reactive authentication checking
  const { checkAuthentication } = useAuthState()
  const parentPickupStore = useParentPickupStore()

  // Debug logging to help trace auth issues
  console.info('Auth Middleware:', {
    path: to.path,
    isAuthenticated: parentPickupStore.isAuthenticated,
    hasSelectedChildren: parentPickupStore.hasSelectedChildren
  })

  const reunificationId = to.params.reunificationId as string
  const isAuthenticated = checkAuthentication(reunificationId)

  // If not authenticated and trying to access a protected page
  if (!isAuthenticated &&
    (to.path.includes('/pickup/children/') ||
      to.path.includes('/pickup/confirmation/') ||
      to.path.includes('/pickup/claimed/') ||
      to.path.includes('/pickup/status/'))) {

    if (reunificationId) {
      // Redirect to authentication page
      console.info('Not authenticated, redirecting to auth page')
      return navigateTo(`/pickup/auth/${reunificationId}`)
    } else {
      // If no reunification ID, redirect to home
      return navigateTo('/')
    }
  }

})